module.exports = __webpack_public_path__ + "img/Festiral2.433bbadb.png";